import React, { useState, useEffect } from "react";
import { Theme } from "../../Helpers/request";
import { Skeleton } from "@mui/material";
import "../../Assets/css/MegaMenu.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const Header = () => {
  const history = useHistory()

 useEffect(()=>{
   if (history?.location?.pathname !== "/diamonds") {
    sessionStorage.removeItem("bw_d_filter");
  }
 },[history?.location?.pathname])

  /* ============= Note - Remove Below code and add selected Theme Header component ====================  */
  const [MegaMenuComponent, setMegaMenuComponent] = useState(null);
  useEffect(() => {

    const loadMegaMenu = async () => {
      let module;
      switch (Theme) {
        case "miami":
          module = await import("../Front/themes/miami/components/Header/MegaMenu");
          break;
        case "newyork":
          module = await import("../Front/themes/newyork/components/Header/MegaMenu");
          break;
        case "london":
          module = await import("../Front/themes/london/Header/MegaMenu");
          break;
        case "macau":
          module = await import("../Front/themes/macau/Header/MegaMenu");
          break;
        case "paris":
          module = await import("../Front/themes/paris/Header/MegaMenu");
          break;
        case "tokyo":
          module = await import("../Front/themes/tokyo/Header/MegaMenu");
          break;
        case "venice":
          module = await import("../Front/themes/venice/Header/MegaMenu");
          break;
        case "dubai":
          module = await import("../Front/themes/dubai/Header/MegaMenu");
          break;
        case "tokyo":
        default:
          module = await import("../Front/themes/tokyo/Header/MegaMenu");
          break;
      }
      setMegaMenuComponent(() => module.default);
    };
    loadMegaMenu();
  }, []);
  if (!MegaMenuComponent) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Skeleton className="m-3" height={40} width={100} />
        <Skeleton className="m-3" height={40} width={100} />
        <Skeleton className="m-3" height={40} width={100} />
        <Skeleton className="m-3" height={40} width={100} />
        <Skeleton className="m-3" height={40} width={100} />
        <Skeleton className="m-3" height={40} width={100} />
        <Skeleton className="m-3" height={40} width={100} />
      </div>
    );
  }

  return <MegaMenuComponent />;
  /* ===========================================   */
};

export default Header;
